import { useEffect, useRef } from 'react';
import { useSocket } from '../context/SocketContext';
import { useDispatch, useSelector } from 'react-redux';
import { setQuizGroups } from '../slices/fun_stuff/quizAuthSlice';
import { toast } from 'react-toastify';

export const useHandleGroupUpdate = () => {
  const socket = useSocket();
  const dispatch = useDispatch();
  const { quizGroups } = useSelector(state => state.quizAuth);

  const quizGroupsRef = useRef(quizGroups);

  useEffect(() => {
    quizGroupsRef.current = quizGroups;
  }, [quizGroups]);

  useEffect(() => {
    if (!socket) return;
    console.log("Setting up group_update listener");

    const handleGroupUpdate =  ({ groupId, type, payload }) => {
      const currentGroups = quizGroupsRef.current;
      console.log(`New group update for group: ${groupId} | type: ${type} | user: ${payload.username}`)

      let groupName = '';
      let updatedGroups;

      if (type === 'member_joined') {
        updatedGroups = currentGroups.map(group => {
          if (group.id === groupId) {
            groupName = group.group_name;
            const alreadyInGroup = group.members?.some(m => m.id === payload.id);
            if (!alreadyInGroup) {
              return {
                ...group,
                members: [...(group.members || []), {
                  id: payload.id,
                  username: payload.username
                }],
              };
            }
          }

          return group;
        });
        console.log(updatedGroups)
        toast.success(`${payload.username} has joined the group ${groupName}`)

      } else if (type === 'new_challenge') {
        updatedGroups = currentGroups.map(group => {
          if (group.id === groupId) {
            groupName = group.group_name;
            return {
              ...group,
              challenges: [...(group.challenges || []), {
                challenge_id: payload.challenge_id,
                quiz: payload.quiz,
                challenger: payload.challenger,
                challenged: payload.challenged,
                completed: payload.completed,
              }],
            }
          }

          return group;
        });

        toast.success(`New challenge received: ${payload.quiz.topic} - ${payload.quiz.level} in group ${groupName}`);
      } else if (type === 'live_group_started') {
        updatedGroups = currentGroups.map(group => {
          if (group.id === groupId) {
            groupName = group.group_name;
            return {
              ...group,
              live_game: true,
            }
          }

          return group;
        });

        toast.success(`New live game created for ${groupName}`);
      } else if (type === 'live_group_ended') {
        updatedGroups = currentGroups.map(group => {
          if (group.id === groupId) {
            groupName = group.group_name;
            return {
              ...group,
              live_game: false,
            }
          }

          return group;
        });

        toast.success(`Live game has ended for ${groupName}`);
      }

      if (updatedGroups) {
        dispatch(setQuizGroups(updatedGroups));
      }
    };

    socket.on('group_update', handleGroupUpdate);

    return () => {
      socket.off('group_update', handleGroupUpdate);
    };
  }, [socket, dispatch]);
};



